import Vue from "vue"
import Vuex from "vuex"
import axios from "axios"
import {router} from "./router";

Vue.use(Vuex);

//var Url = "https://api.asansorcrm.com/"; // TODO : CANLIDA
var Url = "https://aapi.mestav.com.tr/"; // TODO : CANLIDA
//var Url = "http://localhost/aapi/";

const store = new Vuex.Store({
    state: {
        Token: localStorage.getItem('_Token'),
        Personel: JSON.parse(localStorage.getItem('_Personel')),
    },
    mutations: {

        setToken(state, data) {
            if (data.Token) state.Token = data.Token
            if (data.Personel) state.Personel = data.Personel
        },

    },
    actions: {
        initAuth({commit, dispatch}) {
            let token = localStorage.getItem("_Token");
            if (!token) {
                if (location.pathname[1] + location.pathname[2] + location.pathname[3] + location.pathname[4] + location.pathname[5] != 'giris') {
                    router.push("/giris");
                    return false
                }
            }
        },
        Post({commit, dispatch, state}, data) {
            let BaseUrl = null;

            if (!data.Url)
                BaseUrl = Url + data.path;
            else
                BaseUrl = data.Url + data.path;

            return axios.post(
                BaseUrl,
                {...data},
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cache-Control': 'no-cache',
                        'Authorization': state.Token ? 'Bearer ' + state.Token : ''
                    }
                }
            ).then(response => {
                return response.data;
            })
        },
        Put({commit, dispatch, state}, data) {
            let BaseUrl = null;

            if (!data.Url)
                BaseUrl = Url + data.path;
            else
                BaseUrl = data.Url + data.path;

            return axios.put(
                BaseUrl,
                {...data},
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cache-Control': 'no-cache',
                        'Authorization': state.Token ? 'Bearer ' + state.Token : ''
                    }
                }
            ).then(response => {
                return response.data;
            })
        },
        Get({commit, dispatch, state}, data) {
            let BaseUrl = null;
            $("body").addClass('yukleniyor')
            if (!data.Url)
                BaseUrl = Url + data.path;
            else
                BaseUrl = data.Url + data.path;


            if (data.loading != false) data.loading = true;
            return axios.get(
                BaseUrl,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cache-Control': 'no-cache',
                        'Authorization': state.Token ? 'Bearer ' + state.Token : ''
                    }
                }
            ).then(
                response => {

                    if (response.data.Status === 401) {
                        this.dispatch("logout");
                    } else {
                        $("body").removeClass('yukleniyor')
                    }
                    return response.data;

                },
                error => {
                });
        },
        Delete({commit, dispatch, state}, data) {
            let BaseUrl = null;

            if (!data.Url)
                BaseUrl = Url + data.path;
            else
                BaseUrl = data.Url + data.path;

            return axios.delete(
                BaseUrl,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cache-Control': 'no-cache',
                        'Authorization': state.Token ? 'Bearer ' + state.Token : ''
                    }
                }
            ).then(response => {
                return response.data;
            });
        },
        logout({commit}) {
            // commit("clearToken");
            localStorage.clear();
            location.reload();
        },
        title({commit}, data) {
            document.title = "ACRM | " + data
        },
        session({commit, dispatch, state}, data) {
            commit('setToken', data)
        }

    },
    getters: {
        isOturum(state) {
            return !!state.Token;
        },
    },

});

export default store



// WEBPACK FOOTER //
// ./src/store.js